import { Modal } from 'antd'

import { useUpdateURLSearchParams } from '@/hooks/useQuery'

import {
  ConditionCompletePageForm,
  ConditionCompletePageFormProps,
} from './ConditionCompletePageForm'

export const AddConditionCompletePageModal = ({
  onFinish,
}: ConditionCompletePageFormProps) => {
  const updateParams = useUpdateURLSearchParams()

  const handleClose = () => {
    updateParams(
      ['condition_settings', undefined],
      ['edit_condition_settings', undefined],
      ['form_id', undefined]
    )
  }

  return (
    <Modal
      centered
      open
      footer={() => undefined}
      maskClosable={false}
      onCancel={handleClose}
      onClose={handleClose}
      title="Add Condition"
      width={{
        xs: '90%',
        sm: '80%',
        md: '90%',
        lg: '90%',
        xl: '75%',
        xxl: '60%',
      }}
    >
      <ConditionCompletePageForm {...{ onFinish }} />
    </Modal>
  )
}
